import { Language } from '@yleisradio/areena-types';
import { getTranslation } from '../localizations/translations';

/*
 * Content needs to be valid XHTML because of HBBTV-support, verify any changes with this setup!
 */
export function generateDeviceInfoHtml(
  language: Language,
  infoEntries: [string, string][]
): string {
  const deviceTranslations: Record<string, string> = {
    vendor: getTranslation('devices_details_vendor', language),
    model: getTranslation('devices_details_model', language),
    'application version': getTranslation(
      'devices_details_application_version',
      language
    ),
    version: getTranslation('devices_details_version', language),
    software: getTranslation('devices_details_software', language),
    useragent: getTranslation('devices_details_useragent', language),
  };

  return infoEntries
    ? `
      <h2>${getTranslation('devices_title', language)}</h2>
      <div>
        ${infoEntries
          .map(
            ([key, value]) => `
          <div class="device-info">
            <p>
              ${deviceTranslations[key] || `${key}:`} ${value || 'none'}
            </p>
          </div>
        `
          )
          .join('')}
      </div>`
    : '<h2>No device info</h2>';
}
